export const STORE_PROFILES_CONFIG = 'app:STORE_PROFILES_CONFIG';
export function storeProfilesConfig(profilesConfig) {
  return {
    type: STORE_PROFILES_CONFIG,
    profilesConfig
  };
}
